<ion-content>
  <app-challenge-layout>
    <div
      class="challenge__header --m-hidden"
      [appBackgroundImage]="(definition$ | async)?.successImageUrl || 'assets/challenge/challenge.jpg'"
    ></div>
    <div class="challenge__content">
      <div class="challenge__well-done">
        <span class="challenge__well-done__title">
          <ion-text [innerHTML]="((definition$ | async)?.successTitle || 'SUCCESS.THANK_YOU_TITLE') | translate"></ion-text>
        </span>
        <span
          class="challenge__well-done__text"
          [innerHTML]="((definition$ | async)?.successText || 'SUCCESS.THANK_YOU_TEXT') | translate"
        ></span>
        <ion-button
          class="button --primary"
          [innerHTML]="((definition$ | async)?.successButtonText || 'SUCCESS.THANK_YOU_BUTTON_TEXT') | translate"
          (click)="done()"
        ></ion-button>
      </div>
    </div>
  </app-challenge-layout>
</ion-content>
